export const CHANNELS_FETCH_SUCCESS = Symbol('CHANNELS_FETCH_SUCCESS');

/**
 * @param {channelModel[]} channels
 * @return {{type: symbol, payload: {channels: *}}}
 */
export const channelsSuccessAction = (channels) => ({
  type: CHANNELS_FETCH_SUCCESS,
  payload: {
    channels,
  },
});
